<template>
<!-- i icon: &#8505; i with circle icon: &#9432; -->
  <span class="tooltip" :title="text">&#9432;</span>
</template>

<script>
export default {
  name: "Tooltip",
  props: {
    text: String
  },
  methods: {

  },
}
</script>

<style scoped>
.tooltip {
  position: relative;
  display: inline-block;
  vertical-align: text-bottom;
  margin-left: 5px;
}
</style>